module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    class: _vm.sfondoStyle,
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), _c('nav', {
    class: _vm.menuStyle
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n\t\t\t\t\tRutti Migliori\n\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ruttirecenti"
    }
  }, [_vm._v("\n\t\t\t\t\tRutti Recenti\n\t\t\t\t")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/aggiungirutto"
    }
  }, [_vm._v("\n\t\t\t\t\tAggiungi un rutto\n\t\t\t\t")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/info"
    }
  }, [_vm._v("\n\t\t\t\t\tMaggiori informazioni\n\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cookie-policy"
    }
  }, [_vm._v("\n\t\t\t\t\tCookie Policy\n\t\t\t\t")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40b4a9fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu.vue
// module id = 57
// module chunks = 7